export const TOO_SHORT_NUMBER = 8;
export const TOO_LONG_NUMBER = 16;
export const OTP_CODE_LENGTH = 6;
export const WEBSITE_VALUE_MAX_LENGTH = 500;
